<oui-document-viewer
  class="panel-viewer"
  [documentUrl]="fileUrls()"
  [showControls]="true">
  @if (isLoading() && !(loadingService.isLoading$ | async)) {
    <div class="loading-container">
      <oui-loading></oui-loading>
    </div>
  }
  @if (displayFieldsToComplete()) {
    <div>
      <oui-etat-vide
        icon="restore_page"
        title="Des champs semblent manquer.">
      </oui-etat-vide>
      <oui-etat-vide title="Compléter et/ou actualiser vos informations pour voir le document."></oui-etat-vide>
    </div>
  } @else if (!isLoading() && !unsignedDocument()) {
    <oui-etat-vide
      icon="unknown_document"
      title="Erreur dans le chargement du DER"></oui-etat-vide>
  }

  @if (isDocumentRequestMode()) {
    <div
      class="panel-document request-panel"
      oui-document-controls>
      <div class="request-panel-content">
        <div class="request-panel-header">
          <h6>Document d'Entrée en Relation</h6>
          <oui-button
            type="icon"
            color="secondary"
            (click)="closed.emit()">
            <oui-icon>close</oui-icon>
          </oui-button>
        </div>
        @if (!isLoading()) {
          <oui-button
            class="width-fill-available"
            iconPrefix="cached"
            type="outlined"
            (click)="forceDERUpdate()">
            Actualiser le document
          </oui-button>

          @if (displayFieldsToComplete()) {
            <ng-container [ngTemplateOutlet]="missingFieldsBanners"></ng-container>
          } @else if (unsignedDocument() && !isGestionPrivee()) {
            <oui-banner
              title="Informations à mettre à jour ?"
              type="complex"
              description="Vous pouvez corriger celles sur lesquelles vous avez la main dans MyProdémial, puis cliquer sur « Actualiser le document »."
              [action]="updateBannerAction"
              [showCloseButton]="false">
            </oui-banner>
          }
        }
      </div>

      <div class="request-panel-footer">
        @if (continueHint(); as hint) {
          <span class="body-2 color-on-surface-medium text-center">{{ hint }}</span>
        }
        <oui-button
          class="width-100pc"
          type="contained"
          iconSuffix="arrow_forward"
          [disabled]="!canContinue()"
          (click)="continueWithDer()">
          Continuer
        </oui-button>
      </div>
    </div>
  } @else {
    <div
      class="panel-document"
      oui-document-controls>
      <h6>Document d'Entrée en Relation</h6>
      @if (!isLoading()) {
        @if (!displayFieldsToComplete()) {
          @if (!(loadingService.isLoading$ | async)) {
            <span class="body-2 color-on-surface-medium"
              >Dernière mise à jour le {{ $safeNavigationMigration(unsignedDocument()?.updatedDate) | date: 'dd/MM/yyyy à HH:mm' }}
            </span>
          }

          @if (!(loadingService.isLoading$ | async)) {
            <div class="panel-document-file-actions">
              <div
                [ouiTooltip]="signatureTooltip()"
                class="width-fill-available">
                <oui-button
                  class="width-fill-available"
                  iconPrefix="signature"
                  (click)="sendToSignature()"
                  [disabled]="signatureDisabled()">
                  Envoyer en signature
                </oui-button>
              </div>
              <div class="flex-vertical gap-32 width-fill-available">
                @if (signedDocument()) {
                  <oui-menu [menuItems]="downloadMenuItems">
                    <oui-button
                      iconPrefix="download"
                      iconSuffix="arrow_drop_down"
                      type="outlined">
                      Télécharger le document</oui-button
                    >
                  </oui-menu>
                } @else {
                  <oui-button
                    type="outlined"
                    iconPrefix="download"
                    (click)="downloadDocument(unsignedDocument())">
                    Télécharger le document
                  </oui-button>
                }
              </div>
            </div>
          }

          <div class="relative">
            <div class="line-breaker"></div>
          </div>
          @if (!isGestionPrivee()) {
            <oui-banner
              title="Informations à mettre à jour ?"
              type="complex"
              description="Vous pouvez corriger celles sur lesquelles vous avez la main dans MyProdémial, puis cliquer sur « Actualiser le document »."
              [action]="updateBannerAction"
              [showCloseButton]="false">
            </oui-banner>
          }
        }
        <oui-button
          class="width-fill-available"
          iconPrefix="cached"
          [type]="displayFieldsToComplete() ? 'contained' : 'outlined'"
          (click)="forceDERUpdate()">
          Actualiser le document
        </oui-button>

        @if (displayFieldsToComplete()) {
          <div class="relative">
            <div class="line-breaker"></div>
          </div>
          <ng-container [ngTemplateOutlet]="missingFieldsBanners"></ng-container>
        }
      }
    </div>
  }
</oui-document-viewer>

<ng-template #missingFieldsBanners>
  @if (fieldsToCompleteProdemial()) {
    <oui-banner
      title="Champs manquants"
      type="complex"
      description="{{ fieldsToCompleteProdemial() }} dans vos données d'habilitation.
      Vous pouvez mettre à jour ces données sur votre plateforme MyProdémial."
      [action]="updateBannerAction"
      declination="error"
      [showCloseButton]="false">
    </oui-banner>
  }

  @if (fieldsToCompleteSHM()) {
    <oui-banner
      title="Champs manquants"
      type="complex"
      description="{{ fieldsToCompleteSHM() }}"
      [action]="shmBannerAction"
      declination="error"
      [showCloseButton]="false">
    </oui-banner>
  }
</ng-template>
